import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import TradingChart from '../components/Charts/TradingChart';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const API_BASE = 'https://api.mbsmartweb.com/api';

const Dashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [coinRates, setCoinRates] = useState({});
  const [userId, setUserId] = useState('');

  const referralLink = `https://logicranetwork.com/register?ref=${userId || "0000"}`;

 const handleActivateBot = () => {
    navigate('/activate-id');
  };
  // Stats Data
  const stats = [
    { label: 'Main Wallet', value: userData?.['Main Balance'] || '$0.00', change: '+0%', icon: 'fa-dollar', color: 'primary' },
    { label: 'Deposit Wallet', value: userData?.['Upgrade Balance'] || '$0.00', change: '+0%', icon: 'fa-arrow-down ', color: 'success' },
    { label: 'Fuel Wallet', value: userData?.['Fuel Balance'] || '$0.00', change: '+0%', icon: 'fa-arrow-down ', color: 'success' },
    { label: 'Amount Withdrawn', value: userData?.['Total Withdrawal'] || '$0.00', change: '+0%', icon: 'fa-arrow-down', color: 'danger' },
    { label: 'Trading Profit', value: userData?.['Trading Profit'] || '$0.00', change: '+0%', icon: 'fa-balance-scale', color: 'info' },
    { label: 'Direct Joining Income', value: userData?.['Direct Joining Income'] || '$0.00', change: '+0%', icon: 'fa-balance-scale', color: 'info' },
    { label: 'Global Joining Royalty Pool', value: userData?.['Global Joining Royalty Pool'] || '$0.00', change: '+0%', icon: 'fa-dollar', color: 'warning' },
    { label: 'Team Trading Profit', value: userData?.['Team Trading Profit'] || '$0.00', change: '+0%', icon: 'fa-balance-scale', color: 'danger' },
    { label: 'Global Trading Pool', value: userData?.['Global Trading Pool'] || '$0.00', change: '+0%', icon: 'fa-gift', color: 'secondary' },
    { label: 'Leadership Royalty Pool', value: userData?.['Leadership Royalty Pool'] || '$0.00', change: '+0%', icon: 'fa-gift', color: 'primary' },
    { label: 'Rewards', value: userData?.['Rewards'] || '$0.00', change: '+0%', icon: 'fa-gift', color: 'warning' },
  ];

  const activeBots = [
    { name: 'Gold Spot/US Dollar', pair: 'XAUUSD', price: '4,749.685', change: '+0.295 (+0.01%)', status: 'active' },
  ];

  const recentTransactions = [
    { id: 1, type: 'Deposit', amount: 500, status: 'Completed', date: '2024-01-15', icon: 'deposit' },
    { id: 2, type: 'Withdrawal', amount: 100, status: 'Pending', date: '2024-01-14', icon: 'withdrawal' },
    { id: 3, type: 'Profit', amount: 124.50, status: 'Completed', date: '2024-01-13', icon: 'profit' },
    { id: 4, type: 'Bonus', amount: 50, status: 'Completed', date: '2024-01-12', icon: 'bonus' },
  ];
  // Fetch user data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');

        const storedUserId = localStorage.getItem('UserId');
        setUserId(storedUserId || '0000');

        const userRes = await axios.post(`${API_BASE}/userdashboard`, { UserId: storedUserId });

        const formattedData = Array.isArray(userRes.data)
          ? userRes.data.reduce((acc, item) => {
              if (item?.Key && item?.Value !== undefined) acc[item.Key] = item.Value;
              return acc;
            }, {})
          : {};

        setUserData(formattedData);
      } catch (err) {
        console.error(err);
        setError('Failed to load dashboard data.');
        toast.error('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getTransactionIcon = (type) => {
    switch(type.toLowerCase()) {
      case 'deposit': return 'fa-arrow-down';
      case 'withdrawal': return 'fa-arrow-up';
      case 'profit': return 'fa-chart-line';
      case 'bonus': return 'fa-gift';
      default: return 'fa-exchange';
    }
  };

  const getTotalAmount = () => {
    const total = recentTransactions.reduce((sum, tx) => sum + tx.amount, 0);
    return total.toFixed(2);
  };

  const copyReferralLink = () => {
    navigator.clipboard.writeText(referralLink);
    toast.success("Referral link copied!");
  };

  const handleWhatsAppShare = () => {
    const message = encodeURIComponent(`🚀 Join me on LogicraNetwork!\nRegister here: ${referralLink}`);
    window.open(`https://wa.me/?text=${message}`, "_blank");
    toast.success("WhatsApp share opened!");
  };

  if (loading) {
    return (
      <Layout>
        <div className="dashboard-loading">Loading dashboard...</div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="dashboard-error">{error}</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="dashboard-page">
        {/* Welcome Section */}
        <div className="welcome-section">
          <div>
            <h1>Welcome back, {userData?.FullName || 'User'}!</h1>
            <p>Your trading dashboard is ready. Here's what's happening with your account today.</p>
          </div>
         {userData?.Status === '1' ? (
          'Active'
        ) : (
          <>
            Inactive
            <button className="btn-primary" onClick={handleActivateBot}>
              <i className="fa fa-rocket"></i> Activate Bot
            </button>
          </>
        )}
        </div>

        {/* Live Coin Rates */}
        {/* <div className="live-rates-section">
          <div className="rates-header">
            <span className="live-badge">🔴 LIVE</span>
            <span className="rates-title">Market Prices</span>
          </div>
          <div className="rates-grid">
            {Object.entries(coinRates).map(([coin, data]) => (
              <div key={coin} className="rate-item">
                <span className="coin-name">{coin}</span>
                <span className="coin-price">${data.price}</span>
                <span className={`coin-change ${parseFloat(data.change) >= 0 ? 'positive' : 'negative'}`}>
                  {parseFloat(data.change) >= 0 ? '↗' : '↘'} {Math.abs(data.change)}%
                </span>
              </div>
            ))}
          </div>
        </div> */}

        {/* Stats Cards */}
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className={`stat-card ${stat.color}`}>
              <div className="stat-icon">
                <i className={`fa ${stat.icon}`}></i>
              </div>
              <div className="stat-info">
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
                {/* <span className="stat-change positive">{stat.change}</span> */}
              </div>
            </div>
          ))}
        </div>

        {/* Trading Section */}
        <div className="trading-section">
          <div className="section-header">
            <h2>Active Trading</h2>
            <div className="time-filters">
              <button className="active">1m</button>
              <button>30m</button>
              <button>1h</button>
            </div>
          </div>

          <div className="trading-grid">
            <div className="trading-chart">
              <TradingChart />
            </div>
            <div className="trading-info">
              <div className="active-bots">
                <h3>Activated Bots</h3>
                {activeBots.map((bot, index) => (
                  <div key={index} className="bot-card">
                    <div className="bot-info">
                      <h4>{bot.name}</h4>
                      <p>{bot.pair}</p>
                      <div className="bot-price">
                        <span className="current-price">{bot.price}</span>
                        <span className="price-change positive">{bot.change}</span>
                      </div>
                    </div>
 <div className="bot-status-wrapper">
    <span 
        className="custom-bot-badge"
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '4px 12px',
            borderRadius: '9999px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: userData?.Status === '1' ? '#22c55e' : '#ef4444',
            color: 'white'
        }}
    >
        <span 
            className="custom-bot-dot"
            style={{
                width: '8px',
                height: '8px',
                backgroundColor: 'white',
                borderRadius: '9999px',
                display: 'inline-block'
            }}
        ></span>
        {userData?.Status === '1' ? 'Active' : 'Inactive'}
    </span>
</div>
                  </div>
                ))}
              </div>

              {/* <div className="quick-actions">
                <button className="action-btn">
                  <i className="fa fa-chart-line"></i> MT5 Account
                </button>
                <button className="action-btn">
                  <i className="fa fa-calculator"></i> Compound Calc
                </button>
                <button className="action-btn">
                  <i className="fa fa-graduation-cap"></i> GWT Academy
                </button>
              </div> */}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-section">
          {/* Recent Transactions */}
          {/* <div className="recent-transactions">
            <div className="recent-transactions-header">
              <h3>
                <i className="fa fa-history"></i> Recent Transactions
              </h3>
              <a href="/transactions" className="view-all-link">
                View All <i className="fa fa-arrow-right"></i>
              </a>
            </div>

            <div className="transactions-table-wrapper">
              <table className="transaction-table">
                <thead>
                  <tr>
                    <th>Transaction</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {recentTransactions.map((tx) => (
                    <tr key={tx.id}>
                      <td data-label="Transaction">
                        <div className="transaction-type-cell">
                          <div className={`transaction-icon ${tx.icon}`}>
                            <i className={`fa ${getTransactionIcon(tx.type)}`}></i>
                          </div>
                          <span className="transaction-type-text">{tx.type}</span>
                        </div>
                       </td>
                      <td data-label="Amount">
                        <span className={`transaction-amount ${tx.type.toLowerCase()}`}>
                          {tx.type === 'Withdrawal' ? '-' : '+'}${tx.amount.toLocaleString()}
                        </span>
                       </td>
                      <td data-label="Status">
                        <div className={`transaction-status ${tx.status.toLowerCase()}`}>
                          <span className="status-dot"></span>
                          {tx.status}
                        </div>
                       </td>
                      <td data-label="Date">
                        <span className="transaction-date">{tx.date}</span>
                       </td>
                     </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="transaction-footer">
              <div className="transaction-summary">
                <div className="summary-item">
                  <span>Total Transactions:</span>
                  <span>{recentTransactions.length}</span>
                </div>
                <div className="summary-item">
                  <span>Total Amount:</span>
                  <span>${getTotalAmount()}</span>
                </div>
              </div>
              <button className="view-all-transactions">
                View All Transactions <i className="fa fa-arrow-right"></i>
              </button>
            </div>
          </div> */}

          {/* Referral Section */}
          <div className="referral-section">
            <h3><i className="fa fa-users"></i> Referral Program</h3>
            
            <div className="referral-stats">
              <div className="stat">
                <span>Direct Referrals</span>
                <strong>{userData?.Directs || 0}</strong>
              </div>
              <div className="stat">
                <span>Team Members</span>
                <strong>{userData?.["Total Team"] || 0}</strong>
              </div>
            </div>

            <div className="referral-link">
              <input 
                type="text" 
                readOnly 
                value={referralLink}
              />
              <button className="copy-btn" onClick={copyReferralLink}>
                <i className="fa fa-copy"></i> COPY URL
              </button>
            </div>

            <div className="referral-actions">
              <button className="whatsapp-btn" onClick={handleWhatsAppShare}>
                <i className="fa fa-whatsapp"></i> Share via WhatsApp
              </button>
            </div>

            <div className="business-section">
              <h4><i className="fa fa-building"></i> Business Overview</h4>
              <div className="business-grid">
                <div className="business-card">
                  <span>Direct Business</span>
                  <strong>{userData?.['Direct Business'] || '$0.00'}</strong>
                </div>
                <div className="business-card">
                  <span>Total Business</span>
                  <strong>{userData?.['Total Business'] || '$0.00'}</strong>
                </div>
                <div className="business-card">
                  <span>Active Directs</span>
                  <strong>{userData?.['Active Directs'] || 0}</strong>
                </div>
                <div className="business-card">
                  <span>Active Team</span>
                  <strong>{userData?.['Active Team'] || 0}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;